export type BillingPaymentStatus =
  | "pending"
  | "succeeded"
  | "failed"
  | "requires_action"
  | string;

export function needsPaymentRecovery(
  paymentStatus?: BillingPaymentStatus | null,
  subscriptionStatus?: string | null,
): boolean {
  if (
    subscriptionStatus === "past_due" ||
    subscriptionStatus === "unpaid" ||
    subscriptionStatus === "incomplete"
  ) {
    return true;
  }

  return (
    (subscriptionStatus === "active" || subscriptionStatus === "trialing") &&
    (paymentStatus === "failed" || paymentStatus === "requires_action")
  );
}

export function isEntitledSubscriptionStatus(
  subscriptionStatus?: string | null,
): boolean {
  return subscriptionStatus === "active" || subscriptionStatus === "trialing";
}
